<div class="privacy-container">

    <h1 class="title">Privacy Policy for ASHA SATHI</h1>

    <section>
        <h2>Introduction</h2>
        <p>
            ASHA SATHI Applicationis a digital healthcare support platform developed for authorized healthcare workers,
            supervisors, and administrators to facilitate beneficiary registration, health monitoring, survey
            management, healthcare service tracking, and reporting activities.
        </p>
        <p>
            This Privacy Policy explains how information is collected, used, stored, processed, and protected when using
            the ASHA SATHI mobile application. </p>
        <p>
            By accessing or using ASHA SATHI, users agree to the collection and use of information in accordance with
            this Privacy Policy.
        </p>
    </section>

    <section>
        <h2>Information We Collect</h2>
        <p>The application may collect the following categories of information:</p>

        <h3>Personal Information</h3>
        <ul>
            <li>Name</li>
            <li>Mobile Number</li>
            <li>Address</li>
            <li>Gender</li>
            <li>Date of Birth / Age</li>
            <li>Age</li>
            <li>Identification Numbers (where applicable)</li>
            <li>Family Details</li>
            <li>Household Information</li>
        </ul>

        <h3>Health Information</h3>
        <p>
            The application may collect health-related information necessary for healthcare monitoring and government
            health program implementation, including:
        </p>
        <h4>Maternal and Pregnancy Information</h4>
        <ul>
            <li>Pregnancy Status</li>
            <li>Last Menstrual Period (LMP)</li>
            <li>Expected Date of Delivery (EDD)</li>
            <li>Antenatal Care (ANC) Records</li>
            <li>Delivery Information</li>
            <li>Postnatal Care Records</li>
            <li>High-Risk Pregnancy Indicators</li>
            <li>Maternal Health Records</li>
        </ul>

        <h4>Child Health Information</h4>
        <ul>
            <li>Birth Details</li>
            <li>Immunization Records</li>
            <li>Growth Monitoring Information</li>
            <li>Child Healthcare Visit Records</li>
            <li>Child Nutrition Information</li>
        </ul>

        <h4>Beneficiary Health Information</h4>
        <ul>
            <li>Medical History Information</li>
            <li>Health Service Utilization Details</li>
            <li>Survey Data Related to Health Programs</li>
            <li>Survey Responses Related to Health Programs</li>
        </ul>

        <h3>Device Information</h3>
        <p>The application may collect:</p>
        <ul>
            <li>Device Identifier</li>
            <li>Device Model</li>
            <li>Operating System Information</li>
            <li>Application Version</li>
            <li>Crash Reports</li>
            <li>Diagnostic Information</li>
        </ul>

        <h3>Location Information</h3>
        <p>Where permitted and required for program implementation, the application may collect:</p>
        <ul>
            <li>GPS Coordinates</li>
            <li>Location Data</li>
            <li>Survey Location Information </li>
            <li>Field Visit Location Information</li>
        </ul>

    </section>

    <section>
        <h2>How We Use Information</h2>
        <ul>
            <li>Beneficiary Registration</li>
            <li>Healthcare Service Tracking</li>
            <li>Maternal and Child Health Monitoring</li>
            <li>Government Health Program Implementation</li>
            <li>Survey Management</li>
            <li>Public Health Reporting</li>
            <li>Data Analysis</li>
            <li>Monitoring and Evaluation</li>
            <li>Healthcare Administration</li>
            <li>Application Security</li>
            <li>User Authentication</li>
            <li>Technical Support</li>
            <li>Compliance with Legal Requirements</li>
        </ul>
    </section>

    <section>
        <h2>Health Information Usage</h2>
        <p>
            Health-related data is collected strictly for healthcare monitoring and
            public health program implementation.
        </p>

        <div class="highlight-box">
            <strong>Important Disclaimer:</strong><br>
            ASHA SATHI does NOT provide medical diagnosis, treatment recommendations,
            prescriptions, or clinical decision support.
            Users must consult qualified healthcare professionals for medical advice.
        </div>
    </section>

    <section>
        <h2>Data Sharing and Disclosure</h2>

        <p>We do not sell personal or health information.</p>

        <h3>Information may be shared only with:</h3>

        <p><strong>Authorized Government Authorities</strong></p>
        <p>
            Information may be shared with authorized government departments, public health authorities, and healthcare
            administrators for:
        </p>
        <ul>
            <li>Program Monitoring</li>
            <li>Healthcare Service Delivery</li>
            <li>Reporting Requirements</li>
            <li>Public Health Management</li>
        </ul>

        <p><strong>Authorized Personnel</strong></p>
        <p>Access may be provided to:</p>
        <ul>
            <li>Authorized ASHA Workers</li>
            <li>Healthcare Supervisors</li>
            <li>Program Administrators</li>
            <li>Government Healthcare Officials</li>
        </ul>

        <p>
            Access is granted strictly according to user roles and responsibilities.
        </p>

        <p><strong>Legal Requirements</strong></p>
        <p>Information may be disclosed when required by:</p>
        <ul>
            <li>Applicable Laws</li>
            <li>Government Orders</li>
            <li>Court Orders</li>
            <li>Regulatory Authorities</li>
        </ul>
    </section>

    <section>
        <h2>Data Security</h2>

        <p>
            We implement reasonable administrative, technical, and organizational safeguards to protect information
            from:
        </p>

        <ul>
            <li>Unauthorized Access</li>
            <li>Unauthorized Disclosure</li>
            <li>Data Loss</li>
            <li>Misuse</li>
            <li>Alteration</li>
            <li>Destruction</li>
        </ul>

        <p><strong>Security measures may include:</strong></p>

        <ul>
            <li>User Authentication</li>
            <li>Role-Based Access Control</li>
            <li>Secure Data Transmission</li>
            <li>Encrypted Communication Channels</li>
            <li>System Monitoring</li>
        </ul>

        <p>
            While we strive to protect information, no electronic storage or transmission system can be guaranteed to be
            completely secure.
        </p>
    </section>

    <section>
        <h2>Data Retention</h2>

        <p>Information is retained only for:</p>

        <ul>
            <li>Healthcare Program Requirements</li>
            <li>Reporting Obligations</li>
            <li>Administrative Purposes</li>
            <li>Legal and Regulatory Compliance</li>
        </ul>

        <p>
            Data may be deleted, archived, or anonymized when no longer required.
        </p>
    </section>

    <section>
        <h2>User Rights</h2>

        <p>
            Subject to applicable laws and organizational policies, users may have the right to:
        </p>

        <ul>
            <li>Access Information</li>
            <li>Correct Inaccurate Information</li>
            <li>Request Updates</li>
            <li>Request Deletion (where permitted)</li>
            <li>Withdraw Permissions (where applicable)</li>
        </ul>

        <p>
            Requests may be submitted through the designated administrative authority.
        </p>
    </section>

    <section>
        <h2>Permissions Used by the Application</h2>

        <p>
            Depending on functionality, ASHA SATHI may request access to:
        </p>

        <p><strong>Camera</strong></p>
        <p>
            Used for capturing beneficiary photographs, documents, and survey-related images.
        </p>

        <p><strong>Location</strong></p>
        <p>
            Used for field visit verification, survey location tracking, and program monitoring.
        </p>

        <p><strong>Storage</strong></p>
        <p>
            Used for storing and retrieving application-related files and documents.
        </p>

        <p><strong>Internet Access</strong></p>
        <p>
            Required for synchronization, authentication, and communication with backend services.
        </p>
    </section>

    <section>
        <h2>Children's Information</h2>

        <p>
            The application may contain information related to child beneficiaries solely for healthcare monitoring and
            government health program implementation.
        </p>

        <p>
            Such information is collected and managed only by authorized healthcare personnel.
        </p>
    </section>

    <section>
        <h2>Third-Party Services</h2>

        <p>
            The application may utilize third-party services for:
        </p>

        <ul>
            <li>Analytics</li>
            <li>Crash Reporting</li>
            <li>Cloud Infrastructure</li>
            <li>Notification Services</li>
        </ul>

        <p>
            Such providers are required to protect information according to applicable contractual and legal
            obligations.
        </p>
    </section>

    <section>
        <h2>International Data Transfers</h2>

        <p>
            Where applicable, information may be processed on servers located outside the user's immediate geographic
            region while maintaining appropriate safeguards.
        </p>
    </section>

    <section>
        <h2>Changes to This Privacy Policy</h2>

        <p>
            We may update this Privacy Policy from time to time.
        </p>

        <p>
            Any updates will be posted within the application and/or on the official website.
        </p>

        <p>
            Continued use of the application after changes become effective constitutes acceptance of the revised
            Privacy Policy.
        </p>
    </section>
    
    <section>
        <h2>Contact Information</h2>
        <p>
            <strong>Organization:</strong> {{companyName}}<br>
            <strong>Email:</strong><a [href]="'mailto:' + (email || '')">
                {{ email || '-' }}</a> <br>
            <strong>Phone:</strong> +91-9272168395<br>
            <strong>Address:</strong> {{address}}
        </p>
    </section>
        <!-- 
        <section>
  <h2>Important Disclaimer</h2>

  <div class="disclaimer-box">
    <p>
      ASHA SATHI is intended solely for authorized healthcare workers and administrators participating in public health programs.
    </p>

    <p>
      The application is a healthcare data collection, monitoring, and reporting platform.
    </p>

    <p>
      ASHA SATHI does not provide medical diagnosis, treatment recommendations, prescriptions, emergency medical services, or clinical decision-making support.
      Users should seek advice from qualified healthcare professionals regarding medical conditions and treatment.
    </p>
  </div>
        </section> -->

</div>